import { useState, useEffect, useCallback, useMemo } from 'react';
import { CrmBoardService } from '../services/crm-board.service';
import { BoardSummaryResponse } from '../services/responses/board.response';

export const useCrmBoards = () => {
    const [summaries, setSummaries] = useState<BoardSummaryResponse[]>([]);
    const service = useMemo(() => new CrmBoardService(), []);

    const fetchAll = useCallback(async () => {
        try {
            const res = await service.getSummaries();
            setSummaries(res.data.data ?? []);
        } catch (e) {
            console.error(e);
        }
    }, [service]);

    useEffect(() => {
        fetchAll();
    }, [fetchAll]);

    return { summaries, refetch: fetchAll };
};
